var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.name))]):_c('span',[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }